import React, { useEffect, useState } from "react";
import AuthService from "../../../../../api/AuthService";
import UpdateSpecialPricePage from "../../../../../entities/DashboardPage/AccountingModule/SpecialPrice/UpdateSpecialPrice";
// import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
// import { useAlert } from "../../../../../context/AlertContext";

const UpdateSpecialPrice = () => {
  const [loading, setLoading] = useState(false)
  const [itemList, setItemList] = useState()
  //   const {showAlert} = useAlert();

  useEffect(() => {
    getItem();
  },[])

  const getItem = async (text) => {
    setLoading(true);
    
    try {
      const result = await AuthService.getItemsList(text);
      if (result?.success) {
        setItemList(result?.data?.items);
        setLoading(false);
      } else {
    
        setLoading(false);
      }
    } catch (error) {
    
      setLoading(false);
    }
  };


  return(
    
    <>
      <UpdateSpecialPricePage loading={loading} itemList={itemList} handleItemList={getItem}/>

    </>
  )
}

export default UpdateSpecialPrice